import SoftBox from "../components/SoftBox";
import SoftTypography from "../components/SoftTypography";
import SoftInput from "../components/SoftInput";
import SoftButton from "../components/SoftButton";
import SearchIcon from "@mui/icons-material/Search";
import * as React from "react";
import {useState} from "react";
import RetourenAPI from "../api/RetourenAPI";

export default function FindOrder(props) {
    const onSearch = props.onSearch;
    const token = props.token;
    const setOrder = props.setOrder;
    const onSubmitted = props.onSubmitted;

    const [formData, setFormData] = useState({
        'plz': '',
        'orderId': '',
        'email': ''
    });
    const [notFound, setNotFound] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const emailValid = /\S+@\S+\.\S+/.test(formData.email);
    const canSearch = formData.orderId.trim() !== '' && formData.plz.trim() !== '' && emailValid;

    const handleFormData = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value.replace('#', ''),
        });
    };

    const submitFormData = (e) => {
        e.preventDefault();
        onSearch(true);
        setNotFound(false);
        RetourenAPI.findOrder(token, formData.orderId.trim(), formData.plz.trim()).then(res => {
            setOrder({...res.data, orderId: formData.orderId.trim(), plz: formData.plz.trim(), email: formData.email.trim()});
        }).catch(() => {
            setNotFound(true);
        }).finally(() => onSearch(false));
    };

    // Rechtlich notwendig: Widerruf darf auch dann möglich sein, wenn die Order nicht zugeordnet werden kann.
    const widerrufAnyway = () => {
        setSubmitting(true);
        RetourenAPI.createWiderruf(token, {
            orderId: formData.orderId.trim(),
            zip: formData.plz.trim(),
            email: formData.email.trim(),
        }).then(res => {
            onSubmitted(res.data?.status ?? 'RECEIVED');
        }).catch(() => {
            onSubmitted('RECEIVED');
        }).finally(() => setSubmitting(false));
    };

    if (notFound) {
        return (
            <SoftBox textAlign="center">
                <SoftTypography variant="h5" fontWeight="bold" mb={1}>
                    Bestellung nicht gefunden
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={2}>
                    Wir konnten zu deinen Angaben keine Bestellung zuordnen. Du kannst deinen Widerruf
                    dennoch absenden – wir bestätigen dir den Eingang per E-Mail und prüfen ihn manuell.
                </SoftTypography>
                <SoftBox mb={1}>
                    <SoftButton variant="gradient" color="primary" fullWidth disabled={submitting}
                                onClick={widerrufAnyway}>
                        Trotzdem widerrufen
                    </SoftButton>
                </SoftBox>
                <SoftButton variant="text" color="secondary" fullWidth onClick={() => setNotFound(false)}>
                    Angaben korrigieren
                </SoftButton>
            </SoftBox>
        );
    }

    return (<SoftBox component="form" role="form">
        <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Bestellnummer*
                </SoftTypography>
            </SoftBox>
            <SoftInput
                type="text"
                name="orderId"
                required
                onChange={handleFormData}
                placeholder="Bestellnummer"
                value={formData?.orderId}
            />
        </SoftBox>
        <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Postleitzahl*
                </SoftTypography>
            </SoftBox>
            <SoftInput type="text" name="plz" value={formData?.plz} onChange={handleFormData}
                       placeholder="Postleitzahl"
                       required/>
            <SoftTypography variant="caption">
                Gib hier die Postleitzahl an, welche auch für die Bestellung genutzt wurde.
            </SoftTypography>
        </SoftBox>
        <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                    E-Mail*
                </SoftTypography>
            </SoftBox>
            <SoftInput type="email" name="email" value={formData?.email} onChange={handleFormData}
                       placeholder="deine@email.de"
                       required
                       onKeyPress={(e) => {
                           if (e.key === 'Enter' && canSearch) {
                               submitFormData(e);
                           }
                       }}/>
            <SoftTypography variant="caption">
                An diese Adresse senden wir deine Eingangsbestätigung.
            </SoftTypography>
        </SoftBox>

        <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="primary" onClick={submitFormData} fullWidth
                        disabled={!canSearch}>
                Bestellung finden <SearchIcon sx={{transform: 'scaleX(-1)', ml: 1}} strokeWidth={2}/>
            </SoftButton>
        </SoftBox>
    </SoftBox>)
}
